import * as React from "react";

import { CollaborationBarContext } from "./CollaborationBarContext";
import {
  collaborationBarReducer,
  CollaborationBarLocation,
} from "./collaborationBarReducer";
import { CollaborationBarStorage } from "./collaborationBarStorage";

export function CollaborationBarProvider({
  children,
}: React.PropsWithChildren) {
  const [state, dispatch] = React.useReducer(
    collaborationBarReducer,
    undefined,
    () => CollaborationBarStorage.getState(),
  );

  React.useEffect(
    function persistAddress() {
      CollaborationBarStorage.setState(state);
    },
    [state],
  );

  const open = React.useCallback((location?: CollaborationBarLocation) => {
    dispatch({ type: "open", location });
  }, []);

  const close = React.useCallback(() => {
    dispatch({ type: "close" });
  }, []);

  const value = React.useMemo(
    () => ({ isOpen: state.isOpen, location: state.location, open, close }),
    [state.isOpen, state.location, open, close],
  );

  return (
    <CollaborationBarContext.Provider value={value}>
      {children}
    </CollaborationBarContext.Provider>
  );
}
